import { cartHandlers } from "./cart";
import { communitiesHandlers } from "./communities";
import { creatorsHandlers } from "./creators";
import { dashboardHandlers } from "./dashboard";
import { feedHandlers } from "./feed";
import { jobsHandlers } from "./jobs";
import { meHandlers } from "./me";
import { notificationsHandlers } from "./notifications";
import { ordersHandlers } from "./orders";
import { postsHandlers } from "./posts";

export const handlers = [
  ...meHandlers,
  ...feedHandlers,
  ...postsHandlers,
  ...creatorsHandlers,
  ...communitiesHandlers,
  ...jobsHandlers,
  ...cartHandlers,
  ...ordersHandlers,
  ...dashboardHandlers,
  ...notificationsHandlers,
];
